<template>
  <div
    class="finish-wrapper viewport is-fullscreen"
    :class="currentScreen"
    :style="{ backgroundImage: `url(${currentBackground})` }"
  >
    <SnowEffect />
    <div v-show="!shotRedeemed" class="stacked-viewport abs-14 center mt-5">
      <div ref="countdown" class="countdown abs-9 up">
        <div class="countdown-back"></div>
        <div class="countdown-div">
          <div class="countdown-time">
            <div class="countdown-number-container">
              <span class="countdown-number"
                >-{{ parsedCountdown(minutes) }}</span
              >
            </div>
            <span class="countdown-label">Minutes</span>
          </div>

          <span class="countdown-separator"></span>

          <div class="countdown-time">
            <div class="countdown-number-container">
              <span class="countdown-number">{{
                parsedCountdown(seconds)
              }}</span>
            </div>
            <span class="countdown-label">Seconds</span>
          </div>
        </div>
      </div>
      <div
        v-show="!showRedeem"
        ref="order_now"
        class="order-now my-4 abs-3 small up bold"
      >
        Order your<br />
        ice cold shot<br />
        at -18°C
      </div>
    </div>

    <div v-show="shotRedeemed" class="abs-14 center pt-5 trans-y">
      <img class="logo-jm" src="@/assets/images/logo_jaegermeister_white.svg" />
      <div class="small bold up">the secret is</div>
      <div class="xl2 bold up">ice cold</div>
    </div>

    <div class="flex center shot-box">
      <!-- <img src="@/assets/images/shot_without.png" class="shot-image" /> -->
      <!-- <a
        v-if="shotRedeemed"
        href="https://instagram.com/jagermeister"
        ref="instagram"
        target="_blank"
        class="instagram"
      >
        <img src="@/assets/images/instagram.svg"/>  
      </a> -->
    </div>

    <div class="abs-20 pt-5 center">
      <div ref="secret">
        <div class="small bold up">the secret is</div>
        <div class="xl2 bold up">ice cold</div>
      </div>
      <div ref="responsibly" class="tiny wide up bottom">
        <!-- <img
          class="responsibly-claim"
          src="@/assets/images/drink-responsibly.svg"
        /> -->
      </div>

      <div
        ref="slider"
        class="center"
        v-show="!showRedeem && !shotRedeemed && !timesUp"
      >
        <div class="small bold up white redeem-margin">
          Get your free shot at the bar!
        </div>
        <Slider
          knobColor="#DD5A12"
          arrowColor="#E9E3C7"
          labelText="push to redeem"
          @unlocked="sliderUnlocked"
        />
      </div>

      <div v-show="shotRedeemed" class="padding-top">
        <div class="medium bold up mb-5 thank-you">Thanks for playing!</div>
        <div class="small bold mb-5 up">Enjoy your free ICE COLD SHOT.</div>
        <div class="tiny wide up mt-5">
          <!-- <img
            class="responsibly-claim"
            src="@/assets/images/drink-responsibly.svg"
          /> -->
        </div>
      </div>

      <div v-show="timesUp">
        <div class="medium bold up mb-5">Time's up!</div>
        <div class="small up">
          Better hurry next time and get your shot
          <span class="bold up">ice cold</span>.
        </div>
        <!-- <div class="tiny wide up bottom mt-5">
          <img
            class="responsibly-claim"
            src="@/assets/images/drink-responsibly.svg"
          />
        </div> -->
      </div>

      <img
        class="fog"
        src="@/assets/images/fog.png"
        v-show="animationStarted"
      />
    </div>

    <transition name="bounce">
      <div v-show="showRedeem && !timesUp" class="redeem-modal">
        <img :src="logo" alt="logo" class="logo" />
        <h2>Did you get your ice cold shot?</h2>
        <div>
          <div class="btn" @click="showRedeem = false">Not yet</div>
          <div class="btn" @click="redeemShot">Got it!</div>
        </div>
        <strong>CAUTION:</strong>
        By accepting you instantly redeem your free shot for today.
      </div>
    </transition>
  </div>
</template>
<script>
import Slider from "@/components/Slider";
import SnowEffect from "@/components/SnowEffect";
import logo from "@/assets/images/logo_jaegermeister_white.svg";
import { useGameTracking } from "@/composables/useGameTracking";

export default {
  components: { Slider, SnowEffect },
  props: {
    animationStarted: Boolean,
  },
  data() {
    return {
      countdown: null,
      seconds: 0,
      minutes: 18,
      timesUp: false,
      showRedeem: false,
      shotRedeemed: false,
      logo: logo,
      currentBackground: require("@/assets/images/screen-shot.jpg"),
      currentScreen: "screen01",
    };
  },
  mounted() {
    this.resetAnimation();
  },
  destroyed() {
    this.stopCountdown();
  },
  methods: {
    resetAnimation() {
      this.$refs.countdown.style.opacity = 0;
      this.$refs.order_now.style.opacity = 0;
      this.$refs.secret.style.opacity = 0;
      this.$refs.responsibly.style.opacity = 0;
      this.$refs.slider.style.opacity = 0;
    },
    startAnimation() {
      const _this = this;
      this.$anime
        .timeline({
          autoplay: true,
          duration: 1000,
          easing: "linear",
          update: (anim) => {
            if (anim.currentTime >= 3000) {
              _this.$refs.secret.style.display = "block";
            }
            if (anim.currentTime >= 7000) {
              _this.$refs.secret.style.display = "none";
              _this.$refs.slider.style.display = "block";
            }
          },
          complete: () => {
            _this.startCountdown();
          },
        })
        .add({
          targets: _this.$refs.countdown,
          opacity: 1,
          duration: 2000,
        })
        .add(
          {
            targets: _this.$refs.order_now,
            opacity: 1,
            begin: () => {
              this.currentBackground = require("@/assets/images/screen02.jpg");
              this.currentScreen = "screen02";
            },
          },
          1000
        )
        .add(
          {
            targets: [_this.$refs.secret, _this.$refs.responsibly],
            opacity: 1,
          },
          "+=1000"
        )
        .add(
          {
            targets: [_this.$refs.secret, _this.$refs.responsibly],
            opacity: 0,
          },
          "+=2000"
        )
        .add({
          targets: _this.$refs.slider,
          opacity: 1,
          begin: () => {
            this.currentBackground = require("@/assets/images/screen03.jpg");
            this.currentScreen = "screen03";
          },
        });
    },
    startCountdown() {
      this.countdown = setInterval(this.countTimerDown, 1000);
    },
    stopCountdown() {
      clearInterval(this.countdown);
    },
    countTimerDown() {
      if (this.seconds <= 0) {
        this.seconds = 60;
        this.minutes -= 1;
      }
      this.seconds -= 1;

      if (this.minutes < 1) {
        this.$refs.countdown.classList.add("shiny--alert");
        this.$refs.order_now.classList.add("shiny--alert");
      }

      if (this.minutes === 0 && this.seconds === 0) {
        this.timesUp = true;
        this.stopCountdown();
      }
    },
    parsedCountdown(value) {
      return value < 10 ? `0${value}` : value;
    },
    async sliderUnlocked() {
      const { kpiTracker } = useGameTracking();

      // Voucher wird eingelöst (Slider freigeschaltet)
      if (!kpiTracker.voucherRedeemed.value) {
        kpiTracker.setVoucherRedeemed(true);
      }

      this.showRedeem = true;
    },
    async redeemShot() {
      const { kpiTracker, session } = useGameTracking();

      this.showRedeem = false;
      this.shotRedeemed = true;
      this.stopCountdown();

      // Berechne Spielzeit
      if (kpiTracker.gamePlayTimeStart.value !== null) {
        const endTime = Date.now();
        const playTimeSeconds = Math.floor(
          (endTime - kpiTracker.gamePlayTimeStart.value) / 1000
        );
        kpiTracker.setGamePlayTimeSeconds(playTimeSeconds);
      }

      // Update Session mit mark_session_as_finished: true
      // Dies setzt has_finished_game = true im Backend
      // Nutze Step "gameFinished" aus App.vue (behalte bestehenden Call)
      try {
        await session.updateSessionProgress(
          kpiTracker.getKpiData(),
          { step: "gameFinished" },
          true // mark_session_as_finished: true
        );
      } catch (error) {
        console.error("Error updating session:", error);
      }

      this.$store.commit("setGameFinished", true);
    },
  },
  watch: {
    animationStarted() {
      this.startAnimation();
    },
    showRedeem(newValue) {
      if (newValue) {
        this.currentBackground = require("@/assets/images/bg-green-xl.jpg");
        this.currentScreen = "screen-redeem";
      } else {
        this.currentBackground = require("@/assets/images/screen03.jpg");
        this.currentScreen = "screen03";
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.trans-y
  transform: translateY(-25%)

.height-20
  height: 20rem !important

.height-0
  height: 0 !important

.finish-wrapper
  z-index: 100
  width: 100vw
  height: 100vh
  background-color: black
  background-repeat: no-repeat
  background-position: right center
  background-attachment: fixed
  background-size: cover
  overflow: hidden
  transition: background-image 1s ease-in-out
  background-image: url("~@/assets/images/screen-shot.jpg")

  &.screen01
    background-image: url("~@/assets/images/screen-shot.jpg")

  &.screen02
    background-image: url("~@/assets/images/screen02.jpg")

  &.screen03
    background-image: url("~@/assets/images/screen03.jpg")

  &.screen-redeem
    background-image: url("~@/assets/images/bg-green-xl.jpg")

  &::after
    content: ""
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-image: url("~@/assets/images/screen02.jpg")
    background-size: cover
    background-position: center
    opacity: 0
    transition: opacity 2s ease-in-out
    pointer-events: none
    z-index: -1

  &.screen02::after
    opacity: 1

.center
  text-align: center

.countdown
  background-color: #0D4734
  position: relative
  font-family: "Meister"
  border: 12px solid #093225
  border-radius: 20px
  line-height: 1
  height: 38rem !important
  margin-top: -1rem
  margin-right: 1.8rem
  margin-left: 1.8rem
  padding-top: 1rem
  padding-bottom: 1rem



  .countdown-back
    position: absolute
    opacity: 0.35
    left: 50%
    transform: translateX(-50%)


.countdown-div
  display: flex
  align-items: center
  justify-content: space-around
  position: relative

  .countdown-time
    display: flex
    flex-direction: column
    align-items: center
    text-align: center

.countdown-number-container
      display: flex
      align-items: center
      justify-content: center
      position: relative


.countdown-number
  font-size: 7.25rem
  font-weight: bold

  .countdown-number::before
      content: '-'
      font-size: 6.5rem
      margin-right: 0.2rem

.countdown-label
  color: #white
  opacity: 0.7
  font-size: 1.7rem
  font-weight: 700
  margin-top: 1rem
  font-family: "Meister"


.countdown-separator
  width: 2px
  opacity: 0.1
  height: 9rem
  background-color: #FFFFFF
  position: absolute
  left: 52.5%
  transform: translateX(-50%)

.order-now
  font-size: 3.75rem !important
  line-height: 1
  display: flex
  justify-content: center
  align-items: center
  margin-top: 6rem
  white-space: no-wrap

.images-container
    display: flex
    justify-content: center
    position: absolute
    left: 40%
    bottom: 23%
    transform: translate(-50%, 5%)
    gap: 2rem
    height: 38vh

.images-container-redeemed
    display: flex
    justify-content: center
    position: absolute
    left: 40%
    bottom: 23%
    transform: translate(-50%, 3%)
    gap: 2rem
    height: 41vh

.shiny
  text-shadow: 0px 0px 15px #5CED6E
  color: white
  animation: flickerShadowGreen 10s 3s linear infinite

  &.shiny--alert
    text-shadow: 0px 0px 15px #DD5A12
    animation: flickerShadowRed 10s linear infinite

@keyframes flickerShadowGreen
  0%, 19.999%, 22%, 62.999%, 64%, 64.999%, 70%, 100%
    text-shadow: 0px 0px 15px #5CED6E
  20%, 21.999%, 63%, 63.999%, 65%, 69.999%
    text-shadow: none

@keyframes flickerShadowRed
  0%, 19.999%, 22%, 62.999%, 64%, 64.999%, 70%, 100%
    text-shadow: 0px 0px 15px #DD5A12
  20%, 21.999%, 63%, 63.999%, 65%, 69.999%
    text-shadow: none

.up
  text-transform: uppercase

.bold
  font-weight: bold

.wide
  letter-spacing: 0.3rem

.small
  font-size: 1.8rem

.medium
  font-size: 3rem

.big
  font-size: 6rem

.xl
  font-size: 6.75rem

.xl2
  font-size: 7rem

.bottom
  position: absolute
  bottom: 0
  left: 0
  right: 0
  text-align: center
  padding: 2rem

.redeem-margin
  margin-top: 8rem

.redeem-modal
  position: absolute
  border: 12px solid
  --tw-border-opacity: 1
  border-color: #DB6B30
  border-radius: 3.5rem
  background-color: #093225
  --tw-bg-opacity: 1
  padding: 3rem 3rem
  top: 23rem
  left: 0
  margin: 0 2rem
  text-align: center
  user-select: none
  z-index: 10

  h2
    font-size: 3.5rem
    text-transform: uppercase
    margin-bottom: 2rem

  .btn
    font-size: 1.6rem
    padding: 1.25rem .5rem
    display: inline-block
    background-color: white
    color: black
    margin: 2rem 0.5rem
    width: 45%
    text-transform: uppercase
    font-weight: bold
    border-radius: 10px

.logo
  width: 11rem
  height: 11rem !important
  margin-bottom: 2rem

.bounce-enter-active
  animation: bounce-in .3s

.bounce-leave-active
  animation: bounce-in .3s reverse

.responsibly-claim
  height: 0.8rem !important
  margin-top: 1rem

.shot-box
  position: relative

  .instagram
    position: absolute
    bottom: 0
    right: 2rem
    width: 10rem
    height: 10rem
    animation: bounce-in 1.5s

@keyframes bounce-in
  0%
    transform: scale(0)
  50%
    transform: scale(1.2)
  100%
    transform: scale(1)

.fog
  z-index: 9
  position: absolute
  left: 0
  bottom: -10rem
  animation: slideFog 100s 1s linear infinite
  will-change: transform
  transform: translateX(-100%)
  pointer-events: none

@keyframes slideFog
  to
    transform: translateX(20%)

.play_again
  text-transform: uppercase
  margin-top: 20px
  font-size: 20px

.thank-you
  margin-top: 20px
  font-size: 4rem

.shot-image
  margin: 0 auto
  display: block
  min-height: 100%

.logo-jm
  width: 100px
  margin-bottom: 2.5rem
  margin-top: 2rem

.padding-top
  padding-top: 3rem
  padding-left: 2rem
  padding-right: 2rem
</style>
